/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React from 'react';
import OnMount from '@atlassian/jira-common-util-op-triggers/src/on-mount/OpTrigger.tsx';
import tagMauEvent from './TagMauTagMauEvent.tsx';
import type { SubProduct } from './SubProduct.types.tsx';

type Props = {
	subProduct: SubProduct;
};

const TagMauEvent = ({ subProduct }: Props): React.JSX.Element => (
	<OnMount op={tagMauEvent} args={[subProduct]} />
);

export default TagMauEvent;
